(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-time-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brand-time-slider')) {
    customElements.define('brand-time-slider', class extends HTMLElement {
      connectedCallback() {
        this.range = this.querySelector('.slider-range');
        this.topLayer = this.querySelector('.layer-top');
        this.handle = this.querySelector('.slider-handle');
        this.dayLink = this.querySelector('.label-left');
        this.nightLink = this.querySelector('.label-right');
        if (!this.range || !this.topLayer || !this.handle || !this.dayLink || !this.nightLink) return;

        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.range.addEventListener('input', () => {
          this.stopDemo();
          this.update();
        }, options);
        this.range.addEventListener('pointerdown', () => this.stopDemo(), options);
        this.range.addEventListener('keydown', () => this.stopDemo(), options);
        this.range.addEventListener('focus', () => this.stopDemo(), options);
        window.addEventListener('pageshow', () => this.update(), options);
        this.update();

        if (this.demoShown || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.demoShown = true;
          this.demoTimers = [];
          this.topLayer.style.transition = 'clip-path 0.6s cubic-bezier(0.22, 1, 0.36, 1)';
          this.handle.style.transition = 'left 0.6s cubic-bezier(0.22, 1, 0.36, 1)';
          [45, 55, 50].forEach((value, index) => {
            this.demoTimers.push(setTimeout(() => {
              this.range.value = value;
              this.update();
            }, 500 + index * 600));
          });
          this.demoTimers.push(setTimeout(() => this.stopDemo(), 2300));
        }, { threshold: 0.5 });
        this.observer.observe(this.range);
      }

      update() {
        const value = Number(this.range.value);
        this.topLayer.style.clipPath = `inset(0 ${100 - value}% 0 0)`;
        this.handle.style.left = `${value}%`;
        this.reveal(this.dayLink, Math.min(1, Math.max(0, (value - 50) / 30)));
        this.reveal(this.nightLink, Math.min(1, Math.max(0, (50 - value) / 30)));
      }

      reveal(link, opacity) {
        const active = opacity > 0.8;
        link.style.opacity = opacity;
        link.classList.toggle('active', active);
        link.tabIndex = active ? 0 : -1;
        link.setAttribute('aria-hidden', String(!active));
      }

      stopDemo() {
        this.demoShown = true;
        this.observer?.disconnect();
        this.demoTimers?.forEach((timer) => clearTimeout(timer));
        this.demoTimers = [];
        if (this.topLayer) this.topLayer.style.transition = 'none';
        if (this.handle) this.handle.style.transition = 'none';
      }

      disconnectedCallback() {
        this.stopDemo();
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
